import { useMutation } from '@tanstack/react-query';

import { cdrApi } from '@/services';
import type { ApiRequestBody, DeleteResponse } from '@/types/api-types';
import type { MutationOptions } from '@/types/tanstack-query-options';
import type { paths } from '~/generated/cdr/api-schema';
import { deleteUserFavFuncReqSchema } from '~/generated/cdr/zod-schema';
import { QUERY_USER_FAV_FUNC_KEY } from './shared/user-fav-func-query-key';

const PATH = '/v1/userFavFunc/deleteUserFavFunc' as const;

export type DeleteUserFavFuncPayload = ApiRequestBody<
  paths,
  typeof PATH,
  'delete'
>;

type DeleteUserFavFuncResponse = DeleteResponse<paths, typeof PATH>;

export const useMutationDeleteUserFavFunc = (
  options?: MutationOptions<void, DeleteUserFavFuncPayload>,
) => {
  return useMutation({
    mutationKey: [PATH],
    mutationFn: async (payload: DeleteUserFavFuncPayload) => {
      await cdrApi.delete<DeleteUserFavFuncResponse>(PATH, {
        data: deleteUserFavFuncReqSchema.parse(payload),
      });
    },
    meta: {
      dependQueries: [[QUERY_USER_FAV_FUNC_KEY]],
    },
    ...options,
  });
};
